module.exports = __webpack_public_path__ + "media/images/users/kaigo-54fa85c3cdf60db30dcb0a8b870dbfee.jpg";